<template>
  <main class="insights">
    <AppSection class="hero" :data="{ img: '' }">
      <AppHeadline
        class="hero__title"
        :data="{
          content: insights.hero.title,
          type: 2,
        }"
      />
      <div class="hero__container">
        <router-link
          class="hero__card"
          v-for="(item, i) in news.firstItems"
          :key="`intro-${i}`"
          :to="`/insights${item.path}`"
        >
          <div
            class="card__image"
            :style="{
              backgroundImage: `url(${item.acf.image.url})`
            }"
          />
          <div class="card__content">
            <AppSubheading
              class="card__eyelet"
              :data="{
                content: item.acf.category.name,
              }"
            />
            <AppHeadline
              class="card__title"
              :data="{
                content: item.title,
                type: 3,
              }"
            />
            <AppParagraph
              class="card__intro"
              :data="{
                content: item.acf.intro,
              }"
            />
            <div class="card__timer">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path
                  stroke="white"
                  fill="none"
                  d="M15 8c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zM12.9 3.1L8 8"
                />
              </svg>
              <AppSubheading
                class="timer__text"
                :data="{
                  content: `${item.acf['reading_time']} MIN READ`,
                }"
              />
            </div>
          </div>
        </router-link>
      </div>
    </AppSection>

    <AppSection
      class="intro"
      :data="{
        img: { src: insights.intro.img.src }
      }"
    >
      <div class="intro__container">
        <AppHeadline
          :data="{
            content: insights.intro.title,
            type: 2,
          }"
        />
        <span class="section__line intro__line"></span>
        <div class="intro__content-container">
          <AppParagraph
            class="intro__text"
            :data="{
              content: insights.intro.content[0],
            }"
          />
          <div class="intro__second-section">
            <AppParagraph
              class="intro__text"
              :data="{
                content: insights.intro.content[1],
              }"
            />
            <span class="section__line intro__line--small"></span>
            <AppParagraph
              class="intro__text"
              :data="{
                content: insights.intro.content[2],
              }"
            />
          </div>
          <div class="intro__third-section">
            <AppHeadline
              class="intro__text"
              :data="{
                content: insights.intro.contentButton.title,
                type: 3,
              }"
            />
            <AppParagraph
              class="intro__text intro__text--margin"
              :data="{
                content: insights.intro.contentButton.text,
              }"
            />
            <AppButton
              class="intro__button"
              :data="{ content: 'KNOW MORE' }"
              @click.native="$eventHub.$emit('showModal')"
            />
          </div>
        </div>
      </div>
    </AppSection>

    <AppSection
      class="first-section"
      :data="{
        img: { src: '' }
      }"
      v-if="lastItems.length > 0"
    >
      <div :class="[
        'first-section__container',
        lastItems.length % 3 === 2 ? 'first-section__container--margin' : '',
      ]">
        <router-link
          class="first-section__card"
          v-for="(item, i) in news.lastItems"
          :key="`first-section-${i}`"
          :to="`/insights${item.path}`"
        >
          <div
            class="card__image"
            :style="{
              backgroundImage: `url(${item.acf.image.url})`
            }"
          />
          <div class="card__content">
            <AppSubheading
              class="card__eyelet"
              :data="{
                content: item.acf.category.name,
              }"
            />
            <AppHeadline
              class="card__title"
              :data="{
                content: item.title,
                type: 3,
              }"
            />
            <AppParagraph
              class="card__intro"
              :data="{
                content: item.acf.intro,
              }"
            />
            <div class="card__timer">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path
                  stroke="white"
                  fill="none"
                  d="M15 8c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zM12.9 3.1L8 8"
                />
              </svg>
              <AppSubheading
                class="timer__text"
                :data="{
                  content: `${item.acf['reading_time']} MIN READ`,
                }"
              />
            </div>
          </div>
        </router-link>
      </div>
    </AppSection>

    <AppSection
      class="subscribe"
      :data="{
        img: { src: '' }
      }"
    >
      <div class="subscribe__container">
        <AppHeadline
          class="subscribe__title"
          :data="{
            content: 'SUBSCRIBE',
            type: 2,
          }"
        />
        <span class="section__line subscribe__line"></span>
        <AppParagraph
          class="subscribe__text"
          :data="{
            content: 'Get latest news about fundraising, data-driven behavioral change, way ahead of anyone else',
          }"
        />
        <form
          action="#"
          class="newsletter__wrapper"
          novalidate
          ref="form"
          @submit.prevent="send"
        >
          <div class="input__email">
            <div data-anim="fade" data-delay="0.2">
              <input
                type="email"
                name="email"
                ref="email"
                id="email"
                placeholder="YOUR NAME"
                required
              >
              <div class="newsletter__thx" v-show="state === 'sent'" style="transform: scaleY(0)">
                <p style="opacity: 0;">
                  Thanks for your subscription
                </p>
              </div>
            </div>
          </div>

          <div class="input__submit" data-anim="fade" data-delay="0.8" ref="submit">
            <appSubheading
              class="input__submit-text"
              :data="{ content: 'SUBSCRIBE' }"
            />
            <input
              type="submit"
              value=""
            >
          </div>
        </form>

        <AppParagraph
          class="subscribe__advice"
          :data="{
            content: 'We keep your data safe and send you not more than 1-2 useful emails a month. *',
          }"
        />
      </div>
      <AppFooter class="footer" :short="true" />
    </AppSection>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  TweenMax,
  TimelineMax,
  Power4,
  Expo,
} from 'gsap/TweenMax';
import IScroll from 'iscroll/build/iscroll-probe';
import scrollMagic from '@/scripts/scrollMagic';
import { isMobile } from '@/scripts/utils';

import raf from '@/scripts/raf';
import mail from '@/scripts/mail';

import AppSection from '@/components/AppSection.vue';
import AppHeadline from '@/components/AppHeadline.vue';
import AppSubheading from '@/components/AppSubheading.vue';
import AppParagraph from '@/components/AppParagraph.vue';
import AppButton from '@/components/AppButton.vue';
import AppFooter from '@/components/AppFooter.vue';

import insights from '@/assets/data/insights.json';

export default {
  name: 'insights',
  components: {
    AppSection,
    AppHeadline,
    AppSubheading,
    AppParagraph,
    AppButton,
    AppFooter,
  },
  props: {
    haveButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      insights,
      firstItems: [],
      lastItems: [],
      firstAnimationAdded: false,
      secondAnimationAdded: false,
      footerAnimationAdded: false,
      state: false,
    };
  },
  computed: {
    ...mapGetters({ news: 'getNews' }),
  },
  mounted() {
    if (this.news.firstItems.length === 0) {
      this.$store.dispatch('FETCH_NEWS').then(() => {
        this.firstAnimationAdded = true;
        raf.add(() => this.firstEnter(), 'first-animation-insights');

        if (this.news.lastItems.length > 0) {
          this.secondAnimationAdded = true;
          raf.add(() => this.secondEnter(), 'second-animation-insights');
        }
      });
    } else {
      this.firstAnimationAdded = true;
      raf.add(() => this.firstEnter(), 'first-animation-insights');

      if (this.lastItems.length > 0) {
        this.secondAnimationAdded = true;
        raf.add(() => this.secondEnter(), 'second-animation-insights');
      }
    }

    // init controller
    this.controller = new scrollMagic.Controller({ container: '.app__container--insights' });
    this.intro();

    if (isMobile()) {
      // configure iScroll
      this.myScroll = new IScroll('.app__container', {
        scrollX: false,
        scrollY: true,
        scrollbars: true,
        useTransform: false,
        useTransition: false,
        probeType: 3,
        click: true,
        disablePointer: true,
        disableTouch: false,
        disableMouse: false,
      });

      this.controller.scrollPos(() => -this.myScroll.y);

      this.handlerScroll = () => this.controller.update(true);
      this.myScroll.on('scroll', this.handlerScroll);
    }

    TweenMax.set('.subscribe__title', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe__line', { scaleY: 0, transformOrigin: '50% 0%' });
    TweenMax.set('.subscribe__text', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe form', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe__advice', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe .footer', { autoAlpha: 0, y: 50 });
    this.footerAnimationAdded = true;
    raf.add(() => this.footer(), 'footer-animation-insights');
  },
  methods: {
    firstEnter() {
      if (this.firstAnimationAdded) {
        this.firstAnimationAdded = false;
        raf.remove('first-animation-insights');

        const tl = new TimelineMax();
        tl.addLabel('start')
          .fromTo('.hero__title', 1, {
            autoAlpha: 0,
            y: 60,
          }, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start')
          .staggerFromTo('.hero__card', 1, {
            autoAlpha: 0,
            y: 60,
          }, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 0.3, 'start+=0.5');
      }
    },
    secondEnter() {
      if (this.$el.getBoundingClientRect().top < (window.innerHeight / 2)
        && this.secondAnimationAdded) {
        this.secondAnimationAdded = false;
        raf.remove('second-animation-insights');

        const tl = new TimelineMax();
        tl.addLabel('start')
          .staggerFromTo('.first-section__card', 1, {
            autoAlpha: 0,
            y: 60,
          }, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 0.3, 'start');
      }
    },
    intro() {
      const texts = Array.from(this.$el.querySelectorAll('.intro .intro__text'));
      TweenMax.set(texts, { y: 50, autoAlpha: 0 });
      TweenMax.set('.intro .intro__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.intro .intro__button', { autoAlpha: 0, y: 50 });
      TweenMax.set('.intro .intro__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.intro .intro__line--small', { scaleY: 0, transformOrigin: '50% 0' });
      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.intro__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.intro__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.25')
        .to(texts[0], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=0.5')
        .to(texts[0], 1, {
          autoAlpha: 0,
          y: -50,
          ease: Power4.easeInOut,
        }, 'start+=2')
        .to('.intro__container', 2.5, {
          y: -125,
          ease: Power4.easeInOut,
        }, 'start+=2')
        .to(texts[1], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=2.5')
        .to('.intro .intro__line--small', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=3')
        .to(texts[2], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=3.5')
        .to('.intro__second-section', 1, {
          autoAlpha: 0,
          y: -50,
          ease: Power4.easeInOut,
        }, 'start+=5')
        .to(texts[3], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=6')
        .to(texts[3], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=6')
        .to(texts[4], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=6.5')
        .to('.intro__button', 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 'start+=7');

      this.introScene = new scrollMagic.Scene({
        duration: 4000,
        offset: window.innerHeight * 2,
      })
        .setTween(tl)
        .setPin('.insights')
        .addTo(this.controller);
    },
    send() {
      const valid = this.validate();

      if (valid) {
        this.$el.style.pointerEvents = 'none';

        const tl = new TimelineMax({
          paused: true,
          onComplete: () => {
            this.state = 'sent';
            this.$el.style.pointerEvents = 'auto';

            console.log(this.$el.querySelector('.newsletter__thx'));

            TweenMax.to('.newsletter__thx', 1, {
              scaleY: 1,
              transformOrigin: '50% 100%',
              ease: Expo.easeOut,
            });

            TweenMax.to('.newsletter__thx p', 0.7, {
              autoAlpha: 1,
              delay: 1,
              ease: Expo.easeOut,
            });
          },
        });

        tl
          .addLabel('start')
          .to(
            [
              this.$refs.email,
              this.$refs.submit,
            ], 0.7, {
              autoAlpha: 0,
              ease: Expo.easeOut,
            }, 'start+=1',
          );

        const formData = new FormData(this.$refs.form);
        const config = {
          u: '735bf74e451de894cb58a6c71',
          id: '7bec07109a',
          url: 'moonshot.us4',
        };
        const user = {
          email: formData.get('email'),
        };

        mail(config, user).then(response => response.json()
          .then((json) => {
            if (json.result === 'success') {
              tl.play();
              window.fbq('track', 'CompleteRegistration', {
                content_name: 'Subscription to newsletter from landing page',
                value: user.email,
              });
            }
          }).catch((ex) => {
            this.$el.style.pointerEvents = 'auto';
            console.log('ex: ', ex);
          }));
      }
    },
    validate() {
      let valid = false;

      if (!this.regexEmail(this.$refs.email.value)) {
        this.error('email');
      }

      if (this.regexEmail(this.$refs.email.value)) {
        valid = true;
      }

      return valid;
    },
    regexEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    },
    error(input) {
      if (input === 'email') {
        TweenMax.to(this.$refs.line, 0.5, {
          backgroundColor: '#ff1744',
          ease: Expo.easeOut,
          yoyo: true,
          repeat: 1,
        });
      }

      if (input === 'privacy') {
        TweenMax.to(this.$refs.fakeInput, 0.5, {
          borderColor: '#ff1744',
          ease: Expo.easeOut,
          yoyo: true,
          repeat: 1,
        });
      }
    },
    footer() {
      if (this.$el.querySelector('.subscribe').getBoundingClientRect().top < (window.innerHeight / 2)
        && this.footerAnimationAdded) {
        this.footerAnimationAdded = false;
        raf.remove('footer-animation-insights');

        const tl = new TimelineMax();
        tl.addLabel('start')
          .to('.subscribe__title', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start')
          .to('.subscribe__line', 1, {
            scaleY: 1,
            ease: Power4.easeOut,
          }, 'start+=0.25')
          .to('.subscribe__text', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=0.5')
          .to('.subscribe form', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=0.75')
          .to('.subscribe__advice', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=1')
          .to('.subscribe .footer', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=1.25');
      }
    },
  },
  beforeDestroy() {
    if (this.firstAnimationAdded) raf.remove('first-animation-insights');
    if (this.secondAnimationAdded) raf.remove('second-animation-insights');
    if (this.footerAnimationAdded) raf.remove('footer-animation-insights');
    if (isMobile() && navigator.userAgent.indexOf('OS 13_') < 0 && navigator.userAgent.indexOf('Safari') > 0) {
      this.myScroll.off('scroll', this.handlerScroll);
      this.myScroll.destroy();
      this.myScroll = null;
    }
    this.controller.destroy();
    this.controller = null;
    this.introScene.destroy();
    this.introScene = null;
  },
};
</script>

<style lang="scss" scoped>
.insights {
  .hero,
  .first-section {
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;

    background-image: linear-gradient(180deg, #9EA0AC 0%, #141B37 100%);

    &__card {
      margin-top: 60px;
    }

    .card__intro::v-deep p {
      line-height: 1.4;
      height: 70px;
      width: 100%;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

      @include mq($until: ipadP) {
        height: 60px;
      }
    }

    .card__image {
      width: 100%;
      margin-bottom: 10px;

      background-color: rgb(74, 79, 95);
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;

      @include aspect-ratio(1, 1);

      transition: opacity 0.4s $outQuint;

      @include mq($until: ipadP) {
        display: none;
      }
    }

    &__container {
      width: 100%;
      padding: 0 0 60px;

      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-flow: row wrap;

      @include mq($until: ipadP) {
        padding: 20px 0;
      }

      > a {
        width: calc(33.3% - 30px);
        flex: 0 0 calc(33.3% - 30px);
        border-bottom: 1px solid $color-white;
        padding-bottom: 20px;
        opacity: 0;

        &:hover .hero__image {
          opacity: 0.5;
        }

        @include mq($until: ipadP) {
          width: 100%;
          flex: 0 0 100%;

          margin-bottom: 30px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .card__title {
      text-align: left;
    }

    .card__eyelet {
      margin-bottom: 15px;
    }

    .card__timer {
      margin-top: auto;

      svg {
        display: inline-block;
        height: 15px;
      }

      .timer__text {
        display: inline-block;
        margin-left: 10px;
      }
    }

    .card__content {
      height: 22vh;

      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-flow: column nowrap;

      @include mq($until: ipadP) {
        height: 160px;
      }
    }
  }

  .hero {
    height: 200vh;
    padding-top: 60px;

    &__container {
      > a:first-child {
          width: calc(67.7% - 30px);
          flex: 0 0 calc(67.7% - 30px);

          @include mq($until: ipadL) {
            width: calc(68.3% - 30px);
            flex: 0 0 calc(68.3% - 30px);
          }

          @include mq($until: ipadP) {
            width: 100%;
            flex: 0 0 100%;
          }

          .card__image {
            height: calc(33vw - 78px);

            &::before {
              content: none;
            }

            @include mq($until: ipadL) {
              height: calc(33vw - 39px);
            }
          }
        }
    }
  }

  .first-section {
    height: auto;
    @include mq($until: ipadP) {
      padding-bottom: 60px;
    }

    &__container {
      @include mq(ipadP) {
        &.first-section__container--margin > a:last-child {
          margin-left: 45px;
          margin-right: auto;
        }
      }
    }
  }

  .intro,
  .intro__container,
  .intro__second-section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  .intro {
    &__container {
      max-width: 500px;
      text-align: center;
    }

    &__content-container {
      position: relative;
    }

    &__second-section,
    &__third-section {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    &__line--small {
      height: 30px;
    }

    &__text--margin {
      margin: 40px 0;
    }
  }

  .subscribe,
  .subscribe__container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  .subscribe {
    background-image: linear-gradient(134deg, #261E3C 0%, #9F7B8A 100%);

    &__text {
      max-width: 400px;
    }

    .newsletter__thx {
      width: 400px;
    }

    &__container {
      text-align: center;

      form {
        width: 100%;
        max-width: 400px;
        margin: 50px 0;

        display: flex;
        align-items: center;
        justify-content: space-between;

        .input__email {
          flex: 1 1 auto;
          margin-right: 5px;

          input {
            width: 100%;
            padding: 10px 15px;

            color: $color-white;
            border: 1px solid $color-white;
            background-color: transparent;

            &:focus {
              outline: transparent;
            }
          }
        }

        .input__submit {
          position: relative;
          background-color: $color-white;
          padding: 10px 15px;

          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            background-color: transparent;
            border: none;
            cursor: pointer;

            &:focus {
              outline: transparent;
            }

            &::placeholder {
              color: transparent;
            }
          }

          &-text::v-deep h5 {
            color: black;
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    background-image: unset;
  }
}
</style>
